import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row flex justify-between items-center full-width" }

import { useRouter } from "vue-router";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AppCreateButton',
  props: {
    compact: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {

  const props = __props

  const router = useRouter();

  function create(type: "quick-quote" | "proposal") {
    if (type === "quick-quote") {
      router.push({ name: "QuickQuote" });
      return
    }
    router.push({ name: "NewProposal" });
  }

return (_ctx: any,_cache: any) => {
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (__props.compact)
    ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
        key: 0,
        color: "primary",
        label: "New",
        size: "md",
        class: "text-subtitle2 brand-button"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_list, null, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (create('quick-quote')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createTextVNode("Quick Quote")
                        ])),
                        _: 1,
                        __: [4]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                clickable: "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (create('proposal')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_section, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_label, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode("Proposal")
                        ])),
                        _: 1,
                        __: [5]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(__props.vertical ? 'box-column' : 'box-row')
      }, [
        _createVNode(_component_q_btn, {
          color: "primary",
          outline: "",
          style: {"min-width":"130px"},
          label: "Quick Quote",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (create('quick-quote'))),
          "icon-right": "mdi-plus",
          class: "brand-button-dense"
        }),
        _createVNode(_component_q_btn, {
          color: "primary",
          style: {"min-width":"130px"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (create('proposal'))),
          class: _normalizeClass(["brand-button-dense", __props.vertical ? 'q-mt-md' : 'q-ml-xs'])
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[6] || (_cache[6] = _createElementVNode("span", null, "Proposal", -1)),
              _createVNode(_component_q_icon, {
                class: "q-pl-sm",
                name: "mdi-plus"
              })
            ])
          ]),
          _: 1
        }, 8, ["class"])
      ], 2))
}
}

})